import React, { Dispatch, SetStateAction } from 'react';
import Svg, { Polyline } from 'react-native-svg';
import MapPoint from './MapPoint';
import { POINT_CANNOT_REMOVE_ERROR } from '../../constants/AlertMessages';

interface DrawPointProps {
  drawPoints: Array<{
    id: string;
    x: number;
    y: number;
    number: number;
  }>;
  setDrawPoints: Dispatch<SetStateAction<Array<{
    id: string; x: number;
    y: number; number: number
  }>>>;
  imageWidth: number;
  imageHeight: number;
  selectedArea?: {
    points: Array<{ x: number; y: number }>;
  };
  showAlert: any;
  selectedTool: string;
  areaComplete: boolean;
  setAreaComplete: Dispatch<SetStateAction<boolean>>;
  editingShape?: boolean;
}

const DrawPoints = (props: DrawPointProps) => {
  const [previewPoints, setPreviewPoints] = React.useState<Array<{ x: number; y: number }>>([]);

  const {
    drawPoints,
    setDrawPoints,
    imageWidth,
    imageHeight,
    selectedArea,
    showAlert,
    selectedTool,
    areaComplete,
    setAreaComplete,
    editingShape,
  } = props;

  const drawPreviewLines = () => {
    if (!previewPoints || previewPoints.length < 2) return null;

    const closedPreviewPoints = previewPoints.length > 2
      ? [...previewPoints, previewPoints[0]]
      : previewPoints;

    const polylinePoints = closedPreviewPoints
      .map((p) => `${p.x},${p.y}`)
      .join(' ');

    return (
      <Svg
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
        pointerEvents='none'
      >
        <Polyline
          points={polylinePoints}
          fill="none"
          stroke="orange"
          strokeWidth={2}
          strokeDasharray={[5, 5]}
        />
      </Svg>
    );
  };

  return (<>
    {drawPoints.map((point, index) => {
      if (selectedTool === 'rectangle' || selectedTool === 'ellipse') {
        if (index === drawPoints.length - 1) return null;
        return (<MapPoint
          key={point.id || point.number}
          point={point}
          index={index}
          drawPoints={drawPoints}
          imageWidth={imageWidth}
          imageHeight={imageHeight}
          selectedArea={selectedArea}
          setDrawPoints={setDrawPoints}
          setAreaComplete={setAreaComplete}
          showAlert={showAlert}
          selectedTool={selectedTool}
          tapPoint={() => { }}
          deletePoint={() => { }}
          setPreviewPoints={setPreviewPoints}
        />);
      }

      if ((index === 0 && areaComplete)) return null;

      return (
        <React.Fragment key={point.id || point.number}>
          <MapPoint
            point={point}
            index={index}
            drawPoints={drawPoints}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            selectedArea={selectedArea}
            setDrawPoints={setDrawPoints}
            setAreaComplete={setAreaComplete}
            showAlert={showAlert}
            tapPoint={() => {
              const newArr = Object.assign([], drawPoints);
              if (drawPoints.length > 1 && point.number === 0) {
                const newPoint = {
                  x: point.x,
                  y: point.y,
                  number: drawPoints.length,
                };
                newArr.push(newPoint);
                if (newArr.length > 3) setAreaComplete(true);
                setDrawPoints(newArr);
              }
            }}
            deletePoint={() => {
              if (editingShape && point.number !== 0) {
                showAlert(POINT_CANNOT_REMOVE_ERROR);
              } else {
                const newArr = Object.assign([], drawPoints);
                newArr.forEach((val, ind) => {
                  if (val.number === point.number) newArr.splice(ind, 1);
                });
                newArr.forEach((item, i) => {
                  item.number = i;
                });
                setDrawPoints(newArr);
                if (index === newArr.length || newArr.length < 4) {
                  setAreaComplete(false);
                }
              }
            }}
            setPreviewPoints={setPreviewPoints}
          />
        </React.Fragment>
      );
    })
    }
    {previewPoints?.length > 1 && drawPreviewLines()}
  </>);
};

export default DrawPoints;
